module.exports = __webpack_public_path__ + "img/mico.efd9df9.png";